<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3F033B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#3F033B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">{{ msg }}</span>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 text-left pb-2>
        <span class="mainHeader">SCAN ITEM</span>
      </v-flex>
      <v-flex xs12 sm6 pb-4>
        <v-text-field
          ref="scanInput"
          v-model="scanCode"
          autofocus
          outlined
          dense
          color="#b234a9"
          placeholder="Scan the item's QR/barcode, or type the code and press Enter"
          @keyup.enter="lookupItem"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 py-4 v-if="item">
        <v-card class="pa-4 rounded-lg" elevation="0" color="#FFFFFF">
          <v-layout wrap>
            <v-flex xs12 sm4>
              <span class="tablefont">Design</span><br />
              <span class="tst2">{{ item.designId ? item.designId.name : "-" }}</span>
            </v-flex>
            <v-flex xs12 sm4>
              <span class="tablefont">Supplier Design Code</span><br />
              <span class="tst2">{{ item.supplierDesignCode }}</span>
            </v-flex>
            <v-flex xs12 sm4>
              <span class="tablefont">HUID</span><br />
              <span class="tst2">{{ item.HUID || "Not hallmarked" }}</span>
            </v-flex>
            <v-flex xs12 sm4 pt-4>
              <span class="tablefont">Net Weight (gm)</span><br />
              <span class="tst2">{{ item.netWeight }}</span>
            </v-flex>
            <v-flex xs12 sm4 pt-4>
              <span class="tablefont">Count</span><br />
              <span class="tst2">{{ item.count }}</span>
            </v-flex>
            <v-flex xs12 sm4 pt-4>
              <span class="tablefont">Cost (%)</span><br />
              <span class="tst2">{{ item.cost }}</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      scanCode: null,
      item: null,
    };
  },
  methods: {
    lookupItem() {
      if (!this.scanCode) return;
      this.appLoading = true;
      axios({
        method: "get",
        url: "/purchaseitem/scan/" + encodeURIComponent(this.scanCode),
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.item = response.data.data;
          } else {
            this.item = null;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
          this.scanCode = null;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
